module.exports = __webpack_public_path__ + "img/404-dog.4598fbe4.jpg";